export const columns = [
  {
    accessorKey: "yardName",
    header: "Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "rowName",
    header: "Row Name",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.rowName || " "}`,
  },
  {
    accessorKey: "noOfVehicles",
    header: "No. Of Slots",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
